"use client";

import React, { useState } from "react";
const centerImages = [{
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8792.png",
  alt: "Залы основного центра MONA",
  label: "Просторные залы для ежедневных занятий"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8568.png",
  alt: "Оборудование для развития моторики",
  label: "Оборудование для развития моторики"
}, {
  src: "https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8570.png",
  alt: "Пространство для системной ежедневной работы",
  label: "Пространство для системной ежедневной работы"
}];
export default function MainCenterSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prevSlide = () => {
    setActiveIndex(prev => prev === 0 ? centerImages.length - 1 : prev - 1);
  };
  const nextSlide = () => {
    setActiveIndex(prev => prev === centerImages.length - 1 ? 0 : prev + 1);
  };
  return <section id="main-center" className="relative overflow-hidden bg-[#f7f7f4] px-6 py-24 text-slate-950 md:px-12 md:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(15,23,42,0.04),transparent_36%)]" />
        <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-[#166534]/[0.05] blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-600 shadow-sm sm:text-xs">
            Основной центр
          </div>

          <h2 className="mb-6 font-default text-3xl font-bold tracking-[-0.03em] text-slate-950 sm:text-4xl md:text-5xl">
            Основной <span className="text-[#166534]">центр</span>
          </h2>

          <div className="space-y-4 font-default text-lg leading-relaxed text-slate-700">
            <p>
              Основной центр — это база ежедневной работы, где ребёнок получает
              системные занятия, понятную структуру и среду для регулярного
              развития навыков.
            </p>
            <p>
              Здесь формируются основные опоры развития: движение, внимание,
              самостоятельность, бытовые навыки и способность выдерживать
              структуру дня.
            </p>
            <p>
              Это оборудованное пространство для ежедневной практики, где каждая
              зона помогает ребёнку двигаться вперёд последовательно и
              устойчиво.
            </p>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="font-default text-2xl font-semibold tracking-[-0.03em] text-slate-950">
            Пространство основного центра
          </h3>
        </div>

        <div className="mb-10 overflow-hidden rounded-[36px] border border-slate-200/70 bg-white shadow-[0_16px_46px_rgba(15,23,42,0.06)]">
          <div className="relative">
            <img src={centerImages[activeIndex].src} alt={centerImages[activeIndex].alt} className="h-[360px] w-full object-cover md:h-[500px]" />

            <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-[linear-gradient(to_top,rgba(15,23,42,0.72),transparent)] p-6">
              <div>
                <p className="text-sm font-medium uppercase tracking-[0.18em] text-white/70">
                  Пространство центра
                </p>
                <p className="mt-2 font-default text-xl font-semibold text-white">
                  {centerImages[activeIndex].label}
                </p>
              </div>

              <div className="flex gap-3">
                <button type="button" onClick={prevSlide} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition-all hover:bg-white/20" aria-label="Предыдущее фото">
                  ‹
                </button>
                <button type="button" onClick={nextSlide} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-md transition-all hover:bg-white/20" aria-label="Следующее фото">
                  ›
                </button>
              </div>
            </div>
          </div>

          <div className="flex gap-3 overflow-x-auto px-6 py-5">
            {centerImages.map((image, index) => <button key={image.src} type="button" onClick={() => setActiveIndex(index)} className={`shrink-0 overflow-hidden rounded-[20px] border transition-all ${activeIndex === index ? "border-[#166534] shadow-[0_10px_24px_rgba(22,101,52,0.14)]" : "border-slate-200"}`}>
                <img src={image.src} alt={image.alt} className="h-20 w-28 object-cover" />
              </button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 xl:grid-cols-2">
          <div className="rounded-[36px] border border-slate-200/70 bg-white/85 p-8 shadow-[0_16px_46px_rgba(15,23,42,0.06)] backdrop-blur-md md:p-10">
            <h3 className="mb-6 font-default text-2xl font-semibold tracking-[-0.03em] text-slate-950">
              Что есть в основном центре
            </h3>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {["два этажа", "просторные залы", "отдельное помещение для настольного тенниса", "две комнаты для индивидуальных занятий", "кладовая с оборудованием", "сенсорная зона с морским песком", "беговые дорожки", "эллиптические тренажёры", "батуты", "силовые и координационные тренажёры", "отдельные туалеты", "душевые и переодевалки для мальчиков и девочек", "отдельная кухня", "ежедневное приготовление свежей еды", "возможность использовать еду, которую передают родители", "при необходимости центр может приготовить вашу еду"].map(item => <div key={item} className="flex items-start gap-3 rounded-[24px] border border-slate-200/70 bg-[#f8fafc] px-5 py-4">
                  <span className="mt-1 text-[#166534]">•</span>
                  <span className="font-default text-[15px] leading-7 text-slate-700">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="rounded-[36px] border border-slate-200/70 bg-white/85 p-8 shadow-[0_16px_46px_rgba(15,23,42,0.06)] backdrop-blur-md md:p-10">
            <h3 className="mb-6 font-default text-2xl font-semibold tracking-[-0.03em] text-slate-950">
              Что здесь проходит
            </h3>

            <div className="space-y-4">
              {["развитие моторики", "координационные упражнения", "тренировки выносливости", "развитие внимания", "формирование самостоятельности", "бытовые навыки"].map(item => <div key={item} className="flex items-start gap-3 rounded-[24px] border border-slate-200/70 bg-[#f8fafc] px-5 py-4">
                  <span className="mt-1 text-[#166534]">✓</span>
                  <span className="font-default text-[15px] leading-7 text-slate-700">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="mt-8 rounded-[28px] border border-[#166534]/10 bg-[#166534]/[0.04] p-6">
              <p className="font-default text-base leading-7 text-slate-700">
                Основной центр — это пространство регулярной, собранной и
                ежедневной работы, где развитие строится на повторяемости,
                структуре и профессиональном сопровождении.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}